function Timer(duration) {

    this.name = 'timer';

    this.duration = duration;
    this.elapsed = 0;
}

export {Timer};
